import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import ScrollToTop from 'react-scroll-to-top'
import Footer from '../../components/ui/Footer'
import NavbarHome from '../../components/ui/NavbarHome'
import Features from './Features'
import './Home.css'
import ProviderCard from './ProviderCard'
import SendMoneyCard from './SendMoneyCard'
import WorkCard from './WorkCard'
import Banner from './Banner'

export default function Home() {
  const [amount, setAmout] = useState(0)
  const [rate, setRate] = useState(0)
  // const isUserLogin = localStorage.getItem("swToken");
  // useEffect(() => {
  //   const hasTimeoutBeenCalled = sessionStorage.getItem("hasTimeoutBeenCalled");
  //   if (!hasTimeoutBeenCalled && !isUserLogin) {
  //     // set a flag in sessionStorage to indicate that setTimeout has been called
  //     sessionStorage.setItem("hasTimeoutBeenCalled", true);

  //     let timeout = setTimeout(() => {
  //       (async () => {
  //         const { value: email } = await Swal.fire({
  //           title: "Interested to know more?",
  //           input: "email",
  //           inputLabel: "Join us on our journey!",
  //           inputPlaceholder: "Enter your email address",
  //           showCloseButton: true,
  //           confirmButtonText: "Submit",
  //           confirmButtonColor: "#2878bb",
  //         });

  //         if (email) {
  //           //call api to save email
  //           axios.post(`${devURL}/user/fetchEmail`, {
  //             email: email,
  //           });
  //         }
  //       })();
  //     }, 10000);
  //     return () => clearTimeout(timeout);
  //   }
  // }, []);

  return (
    <>
      <Helmet>
        <title>
          ScopeX: Your Reliable Partner for Global Money Transfers - Fast and
          Secure
        </title>
        <meta
          name='description'
          content='Scopex offers a fast, secure, and cost-effective way to transfer money internationally. With zero transfer fees and competitive exchange rates, Scopex is the preferred choice for remittance services. Send money to your loved ones, pay bills, or manage your overseas investments with ease.'
        />
        <meta
          name='keywords'
          content='money transfer, remittance, zero fee, international transfer, send money, Scopex'
        />
        <link rel='canonical' href='https://scopex.money/' />
        <meta
          property='og:title'
          content='ScopeX: Your Reliable Partner for Global Money Transfers - Fast and Secure'
        />
      </Helmet>
      <div>
        <div className='overflow-hidden'>
          <span className='font-nunito relative'>
            <NavbarHome />
            {/* a banner which is only shown mobile devices */}
            <SendMoneyCard setAmout={setAmout} setRate={setRate} />
            {/* <SendMoneyBanner /> */}
            <ProviderCard
              sendingAmount={amount ? amount : 1000}
              sendingRate={rate ? rate : 1}
            />
            <Features />
            <WorkCard />
            <Footer />
            <ScrollToTop
              smooth
              color='#5c6e64'
              style={{
                marginBottom: '44px',
                marginRight: '-12px',
              }}
            />
          </span>
        </div>
      </div>
    </>
  )
}
